<div *ngIf="shouldShowErrors" class="error-msg" [ngClass]="customClass">
  <label [for]="trackByIndex" *ngFor="let message of errorMessages; trackBy: trackByIndex" class="error">
    <img 
      *ngIf="showIcon" 
      [src]="iconPath" 
      alt="Error icon" 
      class="error-icon"
    />
    {{ message }}
  </label>
</div>
